import { stringifyValues } from '@atc/string-fns';
const stringifyForDataLayer = function (obj, inheritPageData) {
  if (inheritPageData === void 0) {
    inheritPageData = true;
  }
  const defaultNonValue = inheritPageData ? undefined : null;
  return Object.entries(obj).reduce((acc, _ref) => {
    let [key, value] = _ref;
    const stringifiedValue = stringifyValues(value, {
      separator: '|'
    }) || defaultNonValue;
    acc[key] = stringifiedValue?.toLowerCase();
    return acc;
  }, {});
};
export default stringifyForDataLayer;